module.exports = __webpack_public_path__ + "static/img/kpsp.468b2b51.png";